export const errorMessages: Record<string, string> = {
  INVALID_EMAIL_OR_PASSWORD: "Email ou senha inválidos",
  INVALID_EMAIL_FIELD: "Email inválido",
  INVALID_PASSWORD_FIELD: "Senha inválida",
  INVALID_PHONE_NUMBER_FIELD: "Telefone inválido",
  INVALID_DATE_FIELD: "Data inválida",
  INVALID_DOCUMENT_FIELD: "CPF inválido",
  REQUIRED_FIELD: "Campo obrigatório",
  FIELD_TOO_SHORT: "Valor muito curto",
  QUOTE_NOT_FOUND: "Orçamento não encontrado",
  QUOTE_ALREADY_ASSIGNED: "Este orçamento já está vinculado a outro usuário",
  UNKNOWN_ERROR: "Ocorreu um erro inesperado",
};

export function getErrorMessage(code?: string) {
  if (!code) return errorMessages.UNKNOWN_ERROR;

  return errorMessages[code] ?? errorMessages.UNKNOWN_ERROR;
}
